import { render } from "./MobileControls.vue?vue&type=template&id=7a48bb72&scoped=true"
import script from "./MobileControls.vue?vue&type=script&lang=js"
export * from "./MobileControls.vue?vue&type=script&lang=js"

import "./MobileControls.vue?vue&type=style&index=0&id=7a48bb72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a48bb72"]])

export default __exports__